import { useMutation } from "@tanstack/react-query";
import { apiPost } from "../api/client";

export interface DiscoverySessionStartResponse {
  session: {
    id: string;
    workspaceId: string;
    userId: string;
    roadmapEntryId: string;
    mode: "voice" | "chat";
    state: string;
    currentPhase: number;
  };
}

export function useStartDiscoverySession(workspaceId: string) {
  return useMutation<
    DiscoverySessionStartResponse,
    Error,
    { roadmap_entry_id: string; mode: "voice" | "chat" }
  >({
    mutationFn: (body) =>
      apiPost<DiscoverySessionStartResponse>(
        `/api/workspaces/${workspaceId}/discovery/sessions`,
        body,
      ),
  });
}

export function useRevisitPhase(sessionId: string) {
  return useMutation<
    { session: { id: string; currentPhase: number; state: string } },
    Error,
    { phase: number; clear_phase_entities?: boolean }
  >({
    mutationFn: (body) =>
      apiPost(`/api/discovery/sessions/${sessionId}/revisit`, body),
  });
}
